import { autoinject, transient } from "aurelia-dependency-injection";
import { AddRightShipInspection } from "../../../rightship-inspection/add-rightship-inspection/add-rightship-inspection";
import { computedFrom } from "aurelia-binding";
import { IRfqMetaPlugin } from "../../../../../../models/rfq/rfq.models";
import { useView } from "aurelia-framework";

@autoinject
@transient()
@useView('views/pages/modules/rfq/plugins/rfq-add-rightship-inspection/rfq-add-rightship-inspection.html')
export class RfqAddRightshipInspection implements IRfqMetaPlugin {
    disableSubmit: boolean;
    model = {};
    canSubmit: boolean = true;
    formHasMultiplePages: boolean = true;
    addRightshipInspectionVM: any = null;
    currentVM: AddRightShipInspection;
    isValid: () => Promise<boolean>;

    @computedFrom("currentVM", "currentVM.rightShipInspectionRequestSubmitted", "currentVM.currentTabIndex")
    get showBackButton(){
        if(this.currentVM){
            return !this.currentVM.rightShipInspectionRequestSubmitted && this.currentVM.currentTabIndex != 0;
        }
    }
    
    @computedFrom("currentVM.rightShipInspectionRequestSubmitted", "currentVM.isLastTab")
    get showNextButton(){
        if(this.currentVM){
            return !this.currentVM.rightShipInspectionRequestSubmitted && !this.currentVM.isLastTab;
        }
    }

    attached(){
        this.currentVM = this.addRightshipInspectionVM.currentViewModel;
        this.currentVM.showActions = false;
    }

    next(){
        this.currentVM.next();
    }

    navigateBack(){
        this.currentVM.navigateBack();
    }

    async getMetaModel() {
        const rsInspection = await this.currentVM.submit(this.currentVM.item, undefined, undefined, true);
        if(rsInspection) rsInspection();
        else throw new Error("Error submitting RightShip Inspection");
        return {
            rightShipInspectionId: this.currentVM.generatedId
        };
    }

    validate() {
        this.currentVM.beforeSave(false, () => { });
    }

    public getViewModel() {
        require('views/pages/modules/rightship-inspection/add-rightship-inspection/add-rightship-inspection.ts');
        require('views/pages/modules/rightship-inspection/add-rightship-inspection/add-rightship-inspection.html');
        return `views/pages/modules/rightship-inspection/add-rightship-inspection/add-rightship-inspection`;
    }
}